<template>
  <div>
    <div style="height: 40px">
      专利导入模板：<el-link type="primary" @click="downloadTemp"
        >下载模板</el-link
      >
    </div>
    <div style="height: 40px">
      <el-select v-model="uploadParams.patentClass" placeholder="选择所属分类">
        <el-option-group label="下一代信息网络产业">
          <el-option label="计算机和辅助设备修理" value="301"></el-option>
          <el-option label="通信系统设备制造" value="302"></el-option>
          <el-option label="通信服务" value="303"></el-option>
          <el-option label="终端设备制造" value="304"></el-option>
          <el-option label="互联网服务" value="305"></el-option>
          <el-option label="其他" value="306"></el-option>
        </el-option-group>
        <el-option-group label="电子核心产业">
          <el-option label="电子材料" value="307"></el-option>
          <el-option label="电子测量仪器制造" value="308"></el-option>
          <el-option label="电子元件制造" value="309"></el-option>
          <el-option label="互联网安全服务" value="310"></el-option>
          <el-option label="半导体器件专用设备制造" value="311"></el-option>
          <el-option label="量子计算" value="312"></el-option>
          <el-option label="其他" value="313"></el-option>
        </el-option-group>
        <el-option-group label="新兴软件和新型信息技术服务">
          <el-option label="网络与信息安全软件服务" value="314"></el-option>
          <el-option label="网络与信息安全软件开发" value="315"></el-option>
          <el-option label="信息技术咨询服务" value="316"></el-option>
          <el-option label="区块链相关" value="317"></el-option>
          <el-option label="量子通信" value="318"></el-option>
          <el-option label="其他" value="319"></el-option>
        </el-option-group>
        <el-option-group label="互联网与云计算、大数据服务">
          <el-option label="互联网制造服务平台" value="320"></el-option>
          <el-option label="大数据服务" value="321"></el-option>
          <el-option label="互联网信息服务" value="322"></el-option>
          <el-option label="互联网平台" value="323"></el-option>
        </el-option-group>
        <el-option-group label="人工智能">
          <el-option label="信息系统集成服务" value="324"></el-option>
          <el-option label="智能终端设备制造" value="325"></el-option>
          <el-option label="人工智能应用软件开发" value="326"></el-option>
          <el-option label="脑部疾病等相关人工智能" value="327"></el-option>
          <el-option label="其他" value="328"></el-option>
        </el-option-group>
      </el-select>
    </div>
    <el-upload
      ref="upload"
      list-type="text"
      :multiple="false"
      :limit="1"
      :action="uploadUrl"
      :before-upload="beforeFileUpload"
      :on-remove="handleRemove"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :auto-upload="false"
      :headers="imgHeaders"
      :data="uploadParams"
      name="fileList"
      accept=".xlsx"
    >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <div slot="tip" class="el-upload__tip">
        只能上传excel文件，且不超过30Mb
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data () {
    return {
      fileList: [],
      imgHeaders: {
        'X-Authorization-With': localStorage.getItem('token')
      },
      uploadUrl: this.COMMON_CONFIG.HTTP_API_CTX + 'file/patent/input/list',
      uploadParams: {
        mtype: 30,
        patentClass: ''
      }
    };
  },
  created () {
    this.fileList = [];
  },
  methods: {
    downloadTemp () {
      this.$http(
        {
          method: 'get',
          url: 'file/load/patent/template',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }).then(response => {
          this.download(response);
        }).catch((error) => {
          this.$message.error(error);
        }
        );
    },
    download (data) {
      if (data.status == 204) {
        this.$message.error("文件不存在.");
        return;
      }

      let fileName = "外文专利导入模板.xlsx";

      let url = window.URL.createObjectURL(new Blob([data.data]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    handleRemove () { },
    submitUpload () {
      if (this.uploadParams.patentClass === '') {
        this.$message.error('请选择分类');
        return;
      }
      this.$refs.upload.submit();
    },
    uploadSuccess (response) {
      // console.log(response);
      if (response.code == 0) {
        this.$emit('uploadOk')
        this.$message.success(response.data);
      } else {
        this.$message.error(response.msg);
      }
    },
    uploadError (err) {
      this.$message.error(err);
    },
    beforeFileUpload (file) {
      const isLtM = file.size / 1024 / 1024 < 30;
      if (!isLtM) {
        this.$message.error('上传文件不能超过30MB!');
      }

      return isLtM;
    }
  },
};
</script>

<style>
.el-upload--text {
  background-color: #fff;
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 85px;
  height: 40px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>